require('./angular-aria');
module.exports = 'ngAria';



/*****************
 ** WEBPACK FOOTER
 ** ./DeliveryCreate/UI/~/angular-aria/index.js
 ** module id = 198
 ** module chunks = 0
 **/